import { render, staticRenderFns } from "./TemplateAddToMenu.vue?vue&type=template&id=640c10b8&scoped=true&"
import script from "./TemplateAddToMenu.vue?vue&type=script&lang=js&"
export * from "./TemplateAddToMenu.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAddToMenu.vue?vue&type=style&index=0&id=640c10b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c10b8",
  null
  
)

export default component.exports